import React, { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import Error from 'views/pages/maintenance/Error';

const Profile = Loadable(lazy(() => import('views/profile')));
const Deployments = Loadable(lazy(() => import('views/deployments')));
const DeploymentRequest = Loadable(lazy(() => import('views/deployment-request')));
const AccessManagement = Loadable(lazy(() => import('views/settings/access-management')));
const TrialRequests = Loadable(lazy(() => import('views/trial-requests')));
const Trials = Loadable(lazy(() => import('views/trials')));
const Units = Loadable(lazy(() => import('views/units')));

const MainRoutes = {
    path: '/',
    element: React.createElement(AuthGuard, null, React.createElement(MainLayout, null)),
    errorElement: React.createElement(Error, null),
    children: [
        {
            path: '/deployments',
            element: React.createElement(Deployments, null)
        },
        {
            path: '/trials',
            element: React.createElement(Trials, null)
        },
        {
            path: '/trial-requests',
            element: React.createElement(TrialRequests, null)
        },
        {
            path: '/deployment-request',
            element: React.createElement(DeploymentRequest, null)
        },
        {
            path: '/access-management',
            element: React.createElement(AccessManagement, null)
        },
        {
            path: '/my-profile',
            element: React.createElement(Profile, null)
        },
        {
            path: '/units',
            element: React.createElement(Units, null)
        }
    ]
};

export default MainRoutes;
